/* @flow */

import React from 'react';
import classNames from 'classnames';
import { Sine } from 'gsap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import useSheet from 'app/jss';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';
import Loader from 'app/components/commons/Loader';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';
import FriendGroupList from './FriendGroupList';
import FriendCreateGroup from './FriendCreateGroup';

type Props = {
  sheet: Object,
  groups: Array<FriendGroup>,
  friendId: number | string,
  isUpdating?: boolean,
  history: Object,
};

type State = {
  creatingNew: boolean,
  groupName: string,
};

class FriendsGroup extends React.Component {
  props: Props;
  state: State = {
    creatingNew: false,
  };

  static defaultProps = {
    isUpdating: false,
  };

  showCreateGroup = () => {
    this.setState({ creatingNew: true });
  }

  showList = () => {
    this.setState({ creatingNew: false });
  }

  onGroupCreate = (newGroupId) => {
    this.showList();
    this.props.history.push(`/groups/${newGroupId}`);
  }

  render() {
    const {
      sheet: { classes },
      groups,
      friendId,
      isUpdating,
    } = this.props;
    const { creatingNew } = this.state;

    const enterParams = {
      duration: 0.5,
      ease: Sine.easeInOut,
      direction: creatingNew ? 'left' : 'right',

    };
    const leaveParams = {
      duration: 0.5,
      ease: Sine.easeInOut,
      direction: creatingNew ? 'left' : 'right',
      simultaneous: true,
    };

    return (
      <AnimatedGroup
        className={classNames(classes.groupsContainer)}
        onEnter={Enter.slide(enterParams)}
        onLeave={Leave.slide(leaveParams)}
      >
        {creatingNew &&
          <FriendCreateGroup
            friendId={friendId}
            onCancel={this.showList}
            onConfirm={this.onGroupCreate}
            key="new"
          />}
        {!creatingNew &&
          <FriendGroupList
            onCreateClick={this.showCreateGroup}
            friendId={friendId}
            groups={groups}
            key="list"
          />}
        <Loader className={classNames(classes.loader, { fadeIn: isUpdating })} />
      </AnimatedGroup>
    );
  }
}

function applyStyles() {
  return {
    groupsContainer: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      position: 'relative',
    },
    loader: {
      position: 'absolute',
      zIndex: 10,
      right: 10,
      bottom: 5,
      opacity: 0,
      transition: 'opacity 0.3s linear',
      padding: 0,
      pointerEvents: 'none',
      '&.fadeIn': {
        opacity: 1,
      },
    },
  };
}

function mapStateToProps(state: GlobalState, { history }) {
  return {
    isUpdating: state.friendGroups.savingGroups.size > 0,
    history,
  };
}

export default withRouter(
  connect(mapStateToProps, {})(
    useSheet(applyStyles)(FriendsGroup),
  ),
);
